/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { NgModule } from '@angular/core';

import { NbSharedModule } from '../shared/shared.module';

import { NbTabsetComponent, NbTabComponent } from './tabset.component';

const NB_TABSET_COMPONENTS = [
  NbTabsetComponent,
  NbTabComponent,
];

@NgModule({
  imports: [
    NbSharedModule,
  ],
  declarations: [
    ...NB_TABSET_COMPONENTS,
  ],
  exports: [
    ...NB_TABSET_COMPONENTS,
  ],
})
export class NbTabsetModule { }



// WEBPACK FOOTER //
// ./src/framework/theme/components/tabset/tabset.module.ts